import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Tabs, Tab, Container } from '@mui/material';
import { Box } from '@livable/saas-react-components';
import NotificationsTab from './NotificationsTab';
import { useStore } from 'src/stores';
export default function NotificationsPage() {
  const store = useStore();
  const tabs = [{
    label: 'Notifications',
    value: 'notifications'
  }, {
    label: 'Settings',
    value: 'settings'
  }];
  if (store.account.featureFlagsStore.getIsActivityLogsEnabled) {
    tabs.push({
      label: 'Activity log',
      value: 'activity-log'
    });
  }
  const _useState = useState('notifications'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  const handleSelectedTabChange = (event, newValue) => setSelectedTab(newValue);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Tabs, {
    type: "navigation",
    position: "sticky",
    value: selectedTab,
    onChange: handleSelectedTabChange,
    "aria-label": "tabs navigation"
  }, tabs.map(tab => /*#__PURE__*/React.createElement(Tab, {
    key: tab.value,
    value: tab.value,
    label: tab.label
  }))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Container, null, selectedTab === 'notifications' && /*#__PURE__*/React.createElement(NotificationsTab, null))));
}